import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // 记录错误信息
    console.error('错误边界捕获到错误:', error, errorInfo);
    
    // 如果是脚本错误（通常来自外部脚本如高德地图），不阻止应用运行
    if (error.message && error.message.includes('Script error')) {
      console.warn('外部脚本错误已忽略，应用继续运行');
      // 重置错误状态，允许应用继续运行
      this.setState({
        hasError: false,
        error: null,
      });
    }
  }

  render() {
    if (this.state.hasError && this.state.error) {
      // 如果是脚本错误，不显示错误UI，让应用继续运行
      if (this.state.error.message && this.state.error.message.includes('Script error')) {
        return this.props.children;
      }

      // 自定义降级 UI
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#666',
          background: '#f5f5f5',
          borderRadius: '8px',
          margin: '20px'
        }}>
          <h2>出现了一些问题</h2>
          <p>页面加载时遇到了错误，请刷新页面重试。</p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            style={{
              padding: '10px 20px',
              marginTop: '10px',
              background: '#C8102E',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            刷新页面
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

